import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import './indexUSP.less';

const fallBackIcon = 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iYmFja2V0LWNoZWNrLWFycm93IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDM1IDM1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzNSAzNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZmlsbD0iIzBBQkY1QSIgZD0iTTI0LjcyLDEwLjg1M2MtMC42NjYtMC40MzctMS41NTktMC4yNS0xLjk5NywwLjQxOWwtNi45NTYsMTAuNjRsLTMuMzI2LTMuMDgyYy0wLjU4NS0wLjU0LTEuNDk4LTAuNTA1LTIuMDM5LDAuMDgxYy0wLjU0MiwwLjU4Ni0wLjUwNSwxLjQ5OCwwLjA4LDIuMDRsNC41OTcsNC4yNTVsMC4wNTMsMC4wMzVsMC4xMDksMC4xMTFsMC4xOTgsMC4wNzZsMC4yMzcsMC4wOTdsMC4yNDEsMC4wMzZsMC4zNDYtMC4wMDRsMC4xNC0wLjAzMmwwLjQwNS0wLjE2OWwwLjA2My0wLjA0NmwwLjI0OC0wLjE3OWwwLjExNi0wLjE4OWwwLjAwNi0wLjAwOGw3Ljg5Ni0xMi4wNzlDMjUuNTc0LDEyLjE4NSwyNS4zODYsMTEuMjksMjQuNzIsMTAuODUzeiIvPjxwYXRoIGZpbGw9IiMwQUJGNUEiIGQ9Ik0xNy41LDAuOTE2Yy05LjEwNCwwLTE2LjQ4NSw3LjM4OC0xNi40ODUsMTYuNWMwLDkuMTEyLDcuMzgxLDE2LjUsMTYuNDg1LDE2LjVzMTYuNDg1LTcuMzg4LDE2LjQ4NS0xNi41QzMzLjk4NSw4LjMwNCwyNi42MDQsMC45MTYsMTcuNSwwLjkxNnogTTE3LjUsMzEuODU0Yy03Ljk1NCwwLTE0LjQyNC02LjQ3OC0xNC40MjQtMTQuNDM4YzAtNy45NjEsNi40Ny0xNC40MzgsMTQuNDI0LTE0LjQzOGM3Ljk1NSwwLDE0LjQyNCw2LjQ3NywxNC40MjQsMTQuNDM4QzMxLjkyNCwyNS4zNzYsMjUuNDUxLDMxLjg1NCwxNy41LDMxLjg1NHoiLz48L2c+PC9zdmc+';

class IndexUSP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usps: [],
            screenType: 'mobile',
            progress: 'wrapper fade notLoaded',
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.setState({ progress: 'wrapper fade fading' }, () => {
          setTimeout(() => {
            this.setState({ progress: 'wrapper fade' });
          }, 250);
        });

        const regex = /(<([^>]+)>)/ig;
        axios.get('/api/get_usp/?type=front_page_-_usp_slider').then((res) => {
            const usps = res.data['front_page_-_usp_slider'];
            for (let i = 0; i < usps.length; i++) {
                usps[i].headline = usps[i].headline ? usps[i].headline.replace(regex, '') : '';
                usps[i].body = usps[i].body ? usps[i].body.replace(regex, '') : '';
            }
            this.setState({ usps });
        }, () => {
            // No error handling
        });
        this.updateDimensions();
    }

    updateDimensions = () => {
        const width = Math.max(
          document.documentElement.clientWidth,
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
        );

        // check what range the width falls into
        const screenType = 0 < width == width < 768 ? 'mobile' :
                    768 <= width == width < 1024 ? 'tablet' :
                    1024 <= width == width < 1350 ? 'desktop' :
                    'desktop-large';

        this.setState({ screenType });
    }

    render() {
        let clipSize;
        switch (this.state.screenType) {
            case 'mobile':
                clipSize = 1;
                break;
            case 'tablet':
                clipSize = 2;
                break;
            case 'desktop':
                clipSize = 3;
                break;
            case 'desktop-large':
                clipSize = 4;
                break;
            default:
                clipSize = 2;
                break;
        }

        const usps = this.state.usps.slice(0, clipSize);
        return (
            <div className={this.state.progress}>
            {usps.map((usp, i) => {
                return (
                  <Fragment key={i}>
                    {usp.link && usp.link.length > 0
                    ?
                    <a href={usp.link} className="uspItem">
                        {
                        usp.icon
                        ? <div className="uspIcon"><img src={`data:image/svg+xml;base64,${usp.icon}`} alt="USP" /></div>
                        : <div className="uspIcon"><img src={`data:image/svg+xml;base64,${fallBackIcon}`} alt="USP" /></div>
                        }
                        <span className="headline">{usp.headline}</span>
                        <span>
                            {' - '}
                            {usp.body}
                        </span>
                    </a>
                    :
                    <div className="uspItem">
                        {
                        usp.icon
                        ? <div className="uspIcon"><img src={`data:image/svg+xml;base64,${usp.icon}`} alt="USP" /></div>
                        : <div className="uspIcon"><img src={`data:image/svg+xml;base64,${fallBackIcon}`} alt="USP" /></div>
                        }
                        <span className="headline">{usp.headline}</span>
                        <span>
                            {' - '}
                            {usp.body}
                        </span>
                    </div>
                    }
                  </Fragment>
                );
              })}
            </div>
        );
    }
}

ReactDOM.render(
    <IndexUSP />,
    document.getElementById('indexUSP'),
);
